import React, { useState } from "react";
import UserAccountDetails from "../UserSettings/UserAccountDetails";
import ChangePasswordLink from "../../features/users/components/ChangePasswordLink";
import "./SettingsPage.css";

export default function SettingsPage() {
  const [activeTab, setActiveTab] = useState("AccountDetails");

  return (
    <div className="settings-page">
      {/* Main Content */}
      <div className="main-content">
        {/* Sidebar */}
        <div className="settings-sidebar">
          <ul>
            <li
              className={activeTab === "AccountDetails" ? "active" : ""}
              onClick={() => setActiveTab("AccountDetails")}
            >
              Account Details
            </li>
           
          </ul>
        </div>

        {/* Content Area */}
        <div className="settings-container">
          {activeTab === "AccountDetails" && <UserAccountDetails />}
          {activeTab === "AccountDetails" && <ChangePasswordLink />}
         
        </div>
      </div>
    </div>
  );
}
